import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { getAreaUrl } from '../../common/areas';

/*
 * Leva um endereco antigo do sistema para o dominio publico novo, preservando
 * o resto do caminho. Ex.: com from="/filme" e to="", /filme/123 vira
 * filmes.../123. Mantem funcionando o catalogo impresso e os links ja enviados.
 */
function AreaRedirect({ area, from, to = '' }) {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const path = `${to}${pathname.slice(from.length)}` || '/';

    window.location.replace(getAreaUrl(area, `${path}${search}`));
  }, []);

  return null;
}

export default AreaRedirect;
